import Header from '../components/Layout/Header';
import { Footer } from 'components/Layout/Footer';
import { AppRoutes } from '../router/Routes';
import Content from 'components/Layout/Content';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CookieConsentPopup from '../components/CookieConsentPopup';
import SupportChatWidget from '../components/SupportChat';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useAuthInitialization } from 'hooks/useAuthInitialization';
import { useReferralCapture } from 'hooks/useReferralCapture';

const CLIENT_ID = process.env.REACT_APP_GAPI_CLIENT_ID;

const App = () => {
  const { pathname } = useLocation();

  // Initialize authorization
  useAuthInitialization();

  // Capture ?ref=<inviter id> for website referral attribution (Phase 4).
  useReferralCapture();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <div className="app">
        <Header />
        <Content>
          <AppRoutes />
        </Content>
        <Footer />
        <CookieConsentPopup />
        <SupportChatWidget />
      </div>
    </GoogleOAuthProvider>
  );
};

export default App;
